// Gift cards ship no `availableOnPlp: false` flag in the Algolia index, so
// Quick Add would otherwise show for them by default (see
// `hit.availableOnPlp !== false` guards in the Hit components). The e-gift
// card is the only gift card product and always carries this parentSku.
export const GIFT_CARD_PRODUCT_CODE = '5027-227';

export const isGiftCardHit = (parentSku?: string | null): boolean =>
  parentSku === GIFT_CARD_PRODUCT_CODE;
